<template>
  <div class="admin-login">
    <div class="login-card">
      <div class="login-logo">🎭</div>
      <h1 class="login-title">Grupo Babilonia</h1>
      <p class="login-subtitle">Panel de Administración</p>

      <form @submit.prevent="login" class="login-form">
        <div class="input-group">
          <input
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            placeholder="Contraseña"
            class="login-input"
            :class="{ 'input-error': error }"
            autofocus
          >
          <button type="button" class="toggle-password" @click="showPassword = !showPassword">
            {{ showPassword ? '🙈' : '👁️' }}
          </button>
        </div>
        <p v-if="error" class="error-message">{{ error }}</p>
        <button type="submit" class="login-btn" :disabled="loading">
          {{ loading ? 'Entrando...' : 'Entrar' }}
        </button>
      </form>

      <router-link to="/" class="back-link">← Volver al sitio</router-link>
    </div>
  </div>
</template>

<script>
const API_BASE = '/api'

export default {
  name: 'AdminLogin',
  data() {
    return {
      password: '',
      showPassword: false,
      error: '',
      loading: false
    }
  },
  mounted() {
    // If already logged in, redirect to intended page or dashboard
    if (sessionStorage.getItem('admin_token')) {
      const redirect = this.$route.query.redirect || '/admin/dashboard'
      this.$router.push(redirect)
    }
  },
  methods: {
    async login() {
      this.error = ''
      this.loading = true
      try {
        const res = await fetch(`${API_BASE}/admin/login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ password: this.password })
        })
        const data = await res.json()
        if (res.ok) {
          sessionStorage.setItem('admin_token', data.token)
          const redirect = this.$route.query.redirect || '/admin/dashboard'
          this.$router.push(redirect)
        } else {
          this.error = 'Contraseña incorrecta'
        }
      } catch {
        this.error = 'Error de conexión'
      }
      this.loading = false
    }
  }
}
</script>

<style scoped>
.admin-login {
  min-height: 100vh;
  background: #0a0a0a;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.login-card {
  background: #111;
  border: 1px solid #222;
  border-radius: 16px;
  padding: 50px 40px;
  width: 100%;
  max-width: 400px;
  text-align: center;
}

.login-logo {
  font-size: 48px;
  margin-bottom: 15px;
}

.login-title {
  font-size: 28px;
  font-weight: bold;
  color: #c9a227;
  margin: 0 0 5px;
}

.login-subtitle {
  font-size: 14px;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  margin: 0 0 35px;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.input-group {
  position: relative;
}

.login-input {
  width: 100%;
  padding: 14px 50px 14px 18px;
  background: #0a0a0a;
  border: 1px solid #333;
  border-radius: 8px;
  color: #fff;
  font-size: 16px;
  outline: none;
  transition: border-color 0.3s;
  box-sizing: border-box;
}

.login-input:focus {
  border-color: #c9a227;
}

.input-error {
  border-color: #e74c3c;
}

.toggle-password {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  padding: 5px;
}

.error-message {
  color: #e74c3c;
  font-size: 14px;
  margin: 0;
}

.login-btn {
  padding: 14px;
  background: #c9a227;
  color: #000;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.login-btn:hover {
  background: #e0b830;
}

.login-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.back-link {
  display: inline-block;
  margin-top: 25px;
  color: #555;
  font-size: 14px;
  text-decoration: none;
  transition: color 0.3s;
}

.back-link:hover {
  color: #c9a227;
}

@media (max-width: 480px) {
  .login-card {
    padding: 35px 25px;
  }
}
</style>
